import * as React from "react";
import { CALENDAR_EVENT_SOURCE_METADATA, CalendarEvent } from "@/interfaces";
import "./styles.scss";
import { Card, Icon, Image, Label } from "semantic-ui-react";
import pluralize from "pluralize";
import moment from "moment";
import { SocialNetworkIcon } from "@/components";
import { useSocialCoachSession } from "@/utils";

type Props = {
  event: CalendarEvent;
  dense?: boolean;
};

export const EventTile: React.FC<Props> = ({ event, dense = false }) => {
  const { isPlayer } = useSocialCoachSession();

  const { label, icon } = CALENDAR_EVENT_SOURCE_METADATA[event.sourceType];

  const scheduledDateTime = new Date(event.scheduledDateTime);
  const timeTextFormat = scheduledDateTime.getMinutes() === 0 ? "ha" : "h:mma";
  const timeText = moment(scheduledDateTime).format(timeTextFormat);

  const noPosts = !event.postStatuses || event.postStatuses.length === 0;

  if (dense) {
    return (
      <div className={`eventTile dense ${event.sourceType.toLowerCase()}`}>
        <Icon name={icon} className={noPosts ? "noPosts" : ""} />
        <span className="eventTime text-xs">{timeText}</span>
        <span className="sourceTitle text-xs">{event.sourceTitle}</span>
      </div>
    );
  } else {
    const promptsCount = event.promptIds.length;
    return (
      <Card className={`eventTile ${event.sourceType.toLowerCase()} ${noPosts ? "noPosts" : ""}`}>
        {event.thumbnail && (
          <div className="thumbnailContainer">
            <Image src={event.thumbnail} wrapped ui={false} />
            {!isPlayer && event.sourceType === "CAMPAIGN" && promptsCount > 0 && (
              <Label basic title={`${promptsCount} ${pluralize("Prompt", promptsCount)}`}>
                <Icon name={promptsCount == 1 ? "file" : "copy"} className={noPosts ? "noPosts" : ""} />
                {promptsCount}
              </Label>
            )}
          </div>
        )}
        <Card.Content>
          <Card.Header>{event.sourceTitle}</Card.Header>
          <Card.Description>
            <div>
              <Icon name={icon} />
              <span>{label}</span>
            </div>
            <div>
              <Icon name="clock" />
              <span>{timeText}</span>
            </div>
            {isPlayer || (
              <div>
                <Icon name="user" />
                <span>
                  {event.playerIds.length} {pluralize("players", event.playerIds.length)}
                </span>
              </div>
            )}
            {event.socialNetworkIds.length > 0 && (
              <div className="socialNetworks">
                {event.socialNetworkIds.map(snId => (
                  <SocialNetworkIcon key={`sn-${snId}`} socialNetworkId={snId} size="tiny" />
                ))}
              </div>
            )}
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
};
